import React, { useState } from "react";

const ShareButton = ({ postId, postTitle }) => {
  const [showPopup, setShowPopup] = useState(false);

  const shareOptions = [
    { name: "Facebook", logo: "📘", url: `https://www.facebook.com/sharer/sharer.php?u=https://example.com/post/${postId}` },
    { name: "Instagram", logo: "📷", url: `https://www.instagram.com/?url=https://example.com/post/${postId}` },
    { name: "LinkedIn", logo: "🔗", url: `https://www.linkedin.com/sharing/share-offsite/?url=https://example.com/post/${postId}` }
  ];

  const handleShareClick = (shareUrl) => {
    window.open(shareUrl, "_blank");
    setShowPopup(false); // Close popup after clicking
  };

  return (
    <div>
      {/* Share span button */}
      <span 
        onClick={() => setShowPopup(!showPopup)}
        style={{ cursor: "pointer", color: "darkgray", fontFamily: "'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif", fontSize: 18 }}
      >
        🔗 Share
      </span>

      {/* Popup Container */}
      {showPopup && (
        <div style={{
          position: "fixed",
          height: "50px",
          top: "57%",
          left: "30%",
          transform: "translate(-50%, -50%)",
          background: "black",
          color: "white",
          padding: "10px",
          borderRadius: "10px",
          boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
          zIndex: 1000,
          marginTop: 30,
          marginLeft: 100,
        }}>
          {/* Social Media Buttons with Logos */}
          {shareOptions.map((option, index) => (
            <span
              key={index}
              onClick={() => handleShareClick(option.url)}
              style={{
                height: "15px",
                fontSize: "20px",
                cursor: "pointer",
                margin: "10px",
                padding: "10px",
                borderRadius: "50%",
                background: "black",  
                display: "inline-block",
                color: "darkgray",
                marginTop: -10,
              }}
              title={option.name}
            >
              {option.logo}
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

export default ShareButton;
